import { graphql } from 'react-apollo'
import { getOffersQuery } from '../queries'
import AdminOfferList from '../components/adminOfferList'

export default graphql(getOffersQuery)(AdminOfferList)



// WEBPACK FOOTER //
// ./src/modules/admin/containers/adminOfferList.js